import { TableFiliais } from "./Components/table/Table";

export const PageFiliais = () => {
  return <TableFiliais />;
};
